import axios, {AxiosResponse} from 'axios'
import {TCieloMerchantRequest} from '../../../coreGlobal/models/admin/cieloMerchant'
import {CieloMerchantsQueryResponse} from './_models'

const API_URL = process.env.REACT_APP_API_URL + '/api'
const CIELO_MERCHANT_URL = `${API_URL}/admin/cielo-merchants`
const FRANCHISE_URL = `${API_URL}/franchises/all`
const BILLING_ENTITY_URL = `${API_URL}/admin/billing-entities/all`
const PAYMENT_OPTION_URL = `${API_URL}/admin/payment_options/all`

// IDs fixos das opções de pagamento Cielo elegíveis para vínculo com Cielo Merchant
const CIELO_PAYMENT_OPTION_IDS = [2, 3]

const getCieloMerchants = (query: string): Promise<CieloMerchantsQueryResponse> => {
  return axios
    .get(`${CIELO_MERCHANT_URL}?${query}&include=franchise,billingEntity,paymentOption`)
    .then((d: AxiosResponse<CieloMerchantsQueryResponse>) => d.data)
}

const getCieloMerchantById = (id: string | number) => {
  return axios
    .get(`${CIELO_MERCHANT_URL}/${id}`)
    .then((response: any) => response.data)
    .then((response: any) => response.data)
}

const createCieloMerchant = (data: TCieloMerchantRequest) => {
  return axios
    .post(`${CIELO_MERCHANT_URL}`, data)
    .then((response: any) => response.data)
    .then((response: any) => response.data)
}

const updateCieloMerchant = (id: string | number, data: TCieloMerchantRequest) => {
  return axios
    .put(`${CIELO_MERCHANT_URL}/${id}`, data)
    .then((response: any) => response.data)
    .then((response: any) => response.data)
}

const getFranchisesSelect = () => {
  return axios
    .get(FRANCHISE_URL)
    .then((response: any) => response.data)
    .then((response: any) => response.data)
    .then((data: any[]) => data.map((item) => ({value: String(item.id), label: item.name})))
}

const getBillingEntitiesSelect = () => {
  return axios
    .get(BILLING_ENTITY_URL)
    .then((response: any) => response.data)
    .then((response: any) => response.data)
}

const getPaymentOptionsSelect = () => {
  return axios
    .get(PAYMENT_OPTION_URL)
    .then((response: any) => response.data)
    .then((response: any) => response.data)
    .then((data: any[]) => data.filter((item) => CIELO_PAYMENT_OPTION_IDS.includes(Number(item.value))))
}

export {
  getCieloMerchants,
  getCieloMerchantById,
  createCieloMerchant,
  updateCieloMerchant,
  getFranchisesSelect,
  getBillingEntitiesSelect,
  getPaymentOptionsSelect,
}
